// GROQ queries for every page the React app can render.
// Keep these thin — the components already know the shape of the data.

export const siteSettingsQuery = /* groq */ `*[_type == "siteSettings"][0]{
  siteName, tagline, ctaLabel, ctaHref,
  nav[]{ label, href, dropdown[]{ title, sub, href } },
  footer{
    tagline,
    columns[]{ heading, links[]{ label, href } },
    bottom
  }
}`;

export const homeQuery = /* groq */ `*[_type == "homePage"][0]{
  seo,
  hero,
  proof,
  metrics,
  grind,
  workforce,
  steerbrain,
  native,
  customers,
  ctaFinal
}`;

export const subPageBySlugQuery = /* groq */ `*[_type == "subPage" && slug.current == $slug][0]{
  "slug": slug.current,
  seo,
  hero,
  sections,
  ctaFinal
}`;
